module.exports = __webpack_public_path__ + "img/company-img2.15802480.png";